/// <reference path="" />

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    /**************************************/
    // Languages View Model      
    /**************************************/
    function LanguagesViewModel() {

        var self = this;

        /***  PROPERTIES ***/
        this.DataList = ko.observableArray();
        /***  PROPERTIES ***/

        /***  SECTION PROPERTIES ***/
        this.DataLoaded = ko.observable(false);
        this.DataLoading = ko.observable(false);
        this.DataContainer = ko.observable("LanguagesContainer");
        this.Touched = ko.observable(false);
        this.IsRequired = ko.observable(false);
        this.DataLoadErrorCount = ko.observable(0);
        this.EnglishPrimaryLanguage = ko.validatedObservable(undefined);
        this.Assessments = ko.observableArray();
        this.IsAPASApplicant = ko.observable();

        this.UpdateTemplateProperties = {
            AddLanguageAssessmentTemplate : ko.observable(''),
            ShowLanguageItemSummary : ko.observable(''),
            HideSetPrimaryLanguage : ko.observable(false),
            LanguageAssessmentText : ko.observable('AddLanguage'),
            LanguageSectionInfoText : ko.observable(''),
            AddLanguageFormTemplate : ko.observable(''),
            LanguagesSummaryInformation : ko.observable(''),
            LanguageMainContainer: ko.observable(''),
            HideCoreFields: ko.observable(false)
        }
        sm.portal.vm.custom.setCustomLocalizeKey(self.UpdateTemplateProperties);

        /***  SECTION PROPERTIES ***/

        /***  LIST DATA PROPERTIES ***/
        this.Languages = ko.observableArray();
        /***  LIST DATA PROPERTIES ***/

        this.WorkingItem = ko.observable(new sm.portal.vm.LanguageDataItem({
            Languages: this.Languages
        }));
        this.OriginalItem = ko.observable(new sm.portal.vm.LanguageDataItem({
            Languages: this.Languages
        }));
        
        sm.portal.vm.custom.callCustomization('UpdateLanguageProperties', self);
        /*** SECTION METHODS ***/
        this.GetLanguageNameById = function (id) {

            for (var i = 0; i < self.Languages().length; i++) {
                if (self.Languages()[i].Value() === id) {
                    return self.Languages()[i].Text();
                }
            }
            return "";
        }

        this.LoadModel = function (container) {
            // update application section configurations
            if (container && container.Payload && container.Payload.Config) {
                viewModel.SetSectionsConfigData("Languages", container.Payload.Config);
            }
            var data = {
                container : container,
                self: self
            }
            //var res = sm.portal.vm.custom.callCustomization('SetEnglishLanguageId', self);
            self.IsAPASApplicant(container.Payload.IsAPASApplicant);
            self.UpdateTemplateProperties.HideSetPrimaryLanguage(container.Payload.IsAPASApplicant);
            sm.portal.vm.custom.callCustomization('LoadModelForLanguageSection', data,
                function(){
                    if (container.Payload.ListData) {
                        self.Languages = smapi.access.loadListItemModels(container.Payload.ListData.LanguageOptions, self.Languages);
                    }
                    //if (container.Payload.Languages != null || (!sm.portal.utility.isNullOrEmpty(res) && container.Payload.Languages.length > 0)) 
                    if (container.Payload.Languages != null) {
                        for (var i = 0; i < container.Payload.Languages.length; i++) {    
                            var language = container.Payload.Languages[i];
                            var newDataItem = new sm.portal.vm.LanguageDataItem({
                                LanguageID: language.LanguageID,
                                Language: language.Language,
                                Proficiency: language.Proficiency,
                                IsPrimary: language.IsPrimary,
                                Languages: self.Languages,
                                EducationReceived: language.EducationReceived,
                                QualificationsObtained: language.QualificationsObtained,
                                ID: language.ID,
                                GID: language.GID
                            });
    
                            self.DataList.push(newDataItem);
                        }
                    }
                }
            )            
            var customData = {
                self: self,
                container: container
            }
            self.DataLoading(false);
            self.DataLoaded(true);
            if (smapi.constant.applicationDebugFlag) { console.log('[LanguagesVM] Data Loaded'); }
        };

        this.GetModelData = function (blockui, applicationMID, personMID, callback) {
            
            if (!this.DataLoaded() && !this.DataLoading()) {
                this.DataLoading(true);               
                if(!sm.portal.utility.isNullOrEmpty(viewModel.allCustomData())) {
                    var customData = {
                        self : self,
                        applicationMID : applicationMID
                    }
                    sm.portal.vm.custom.callCustomization('GetModelDataForLanguage', customData);
                    self.LoadModel(viewModel.allCustomData().Languages);
                    callback && callback(viewModel.allCustomData().Languages);
                    return;
                }
                if (blockui) { jQuery.blockUI(); }
                var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/getapplicationsection?sectionName=languages&attemptmid={0}', applicationMID);

                jQuery.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1' //,
                    },
                    processData: false,
                    crossDomain: true,

                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {
                        var customData = {
                            self : self,
                            applicationMID : applicationMID
                        }
                        sm.portal.vm.custom.callCustomization('GetModelDataForLanguage', customData);
                        sm.portal.page.application.modelDataResponseHandler(self, data, applicationMID, personMID);
                        callback && callback(data);
                    },
                    error: function (jqXHR, exception) {
                        sm.portal.page.application.modelErrorHandler(self, jqXHR);
                        sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'fetch');
                        callback && callback();
                    }
                });
            } else {
                callback && callback();
            }
        };
        this.EditItem = function (data, event) {

            self.OriginalItem(data);

            self.WorkingItem(new sm.portal.vm.LanguageDataItem(JSON.parse(ko.toJSON(data))));

            self.WorkingItem().InEditMode(true);
            var res = sm.portal.vm.custom.callCustomization('EditItemForLanguage', self);
            //Close the view and display the data entry
            if(sm.portal.utility.isNullOrEmpty(res)){
                jQuery('.dataDisplayView').hide();
                jQuery('.dataEntryView').show();
            }
        };
        this.AddItem = function (data, event) {
            sm.portal.vm.custom.callCustomization('AddItemForLanguage', data);
            sm.portal.vm.custom.callCustomization('ResetWorkingItemForLanguage', self); 
            self.WorkingItem(new sm.portal.vm.LanguageDataItem(JSON.parse(ko.toJSON(data))));
        };

        this.SaveWorkingChanges = function (data, event) {
            var workingItem = sm.portal.vm.custom.callCustomization('SaveWorkingChangesForLanguage', self);
            
            if(!workingItem){
                if (self.WorkingItem().IsPrimary()) {
                    self.SetPrimary(self.WorkingItem());
                }
    
                workingItem = new sm.portal.vm.LanguageDataItem({
                    LanguageID: self.WorkingItem().LanguageID(),
                    Language: self.WorkingItem().Language(),
                    Proficiency: self.WorkingItem().Proficiency(),
                    IsPrimary: self.WorkingItem().IsPrimary(),
                    InEditMode: self.WorkingItem().InEditMode(),
                    SectionRequired: self.IsRequired(),
                    Languages: this.Languages,
                    EducationReceived: self.WorkingItem().EducationReceived(),
                    QualificationsObtained: self.WorkingItem().QualificationsObtained(),
                    ID: self.WorkingItem().ID(),
                    GID: self.WorkingItem().GID(),
                });
    
                if (workingItem.LanguageID()) {
                    workingItem.Language(self.GetLanguageNameById(workingItem.LanguageID()).name);
                }
    
                self.WorkingItem(new sm.portal.vm.LanguageDataItem({
                    Languages: this.Languages
                })); 
            }
            

            if (workingItem.IsVMValid()) {

                if (!workingItem.InEditMode()) {
                    // This is an Add...
                    self.DataList.push(workingItem);
                } else {
                    // NOTE: Edits automatically bind back to the list (knockout is cool, huh?)
                    workingItem.InEditMode(false);
                    self.OriginalItem().LanguageID(workingItem.LanguageID());
                    self.OriginalItem().Language(workingItem.Language());
                    self.OriginalItem().Proficiency(workingItem.Proficiency());
                    self.OriginalItem().IsPrimary(workingItem.IsPrimary());
                    self.OriginalItem().InEditMode(workingItem.InEditMode());
                    self.OriginalItem().ID(workingItem.ID());
                    self.OriginalItem().GID(workingItem.GID());
                    var customData = {
                        self: self,
                        workingItem: workingItem
                    }
                    sm.portal.vm.custom.callCustomization('UpdatePropertiesForSaveWorkingChanges', customData);
                }

                // hide the data entry view
                jQuery('.dataEntryView').hide();

                // show the display view with one item
                jQuery('.dataDisplayView').show();
                jQuery('.dataDisplayView ul.detailedList li').not('.noneAdded').show();
                var res = sm.portal.vm.custom.callCustomization('IsCancelWorkingChangesRequired');
                if(res){
                    this.CancelWorkingChanges();
                }
            }
        };
        sm.portal.vm.custom.callCustomization('ValidationsForLanguage', self);
        this.RemoveItem = function (data, event) {
            var res = sm.portal.vm.custom.callCustomization('RemoveAccessibilityDataItem', self);
            if (!sm.portal.utility.isNullOrEmpty(res)) {
                return res;
            }
            self.DataList.remove(function (item) {
                return item.LanguageID == data.LanguageID &&
                    item.Proficiency == data.Proficiency &&
                    item.IsPrimary == data.IsPrimary &&
                    item.EducationReceived == data.EducationReceived &&
                    item.QualificationsObtained == data.QualificationsObtained;
            });
        };
        this.CancelWorkingChanges = function () {
            sm.portal.vm.custom.callCustomization('CancelWorkingChangesForLanguages', self,
                function(){
                    self.WorkingItem(new sm.portal.vm.LanguageDataItem({
                        Languages: this.Languages
                    }));
                }
            );
            

            //hide the display view
            jQuery('.dataEntryView').hide();
            // show the entry view
            jQuery('.dataDisplayView').show();
        }
        this.SetPrimary = function (data, event) {
            // set all other primary flags to false
            jQuery.each(self.DataList(), function (k, language) {
                language.setPrimary(false);
            });
            // set this primary flag to true
            data.IsPrimary(true);
        }
        this.BlockContainer = function () {
            jQuery("#" + self.DataContainer()).block({ message: sm.portal.utility.getResourceValue('Loading') });
        };
        this.UnBlockContainer = function () {
            jQuery("#" + self.DataContainer()).unblock();
            viewModel.SetFocus();
        };
        this.ProcessOnServer = function () {
            return true;
        };
        this.ExtractATO = function () {
            var atoList = Array();
            var data = {
                self: self,
                atoList: atoList
            }
            sm.portal.vm.custom.callCustomization('ExtractLanguageATO', data, 
                function () {
                    for (var i = 0; i < self.DataList().length; i++) {
                        var dataListItem = self.DataList()[i];
                        var ato = dataListItem.ExtractATO();
                        atoList.push(ko.toJS(ato));
                    }                            
                }
            );

            return atoList;
        };

        /*** SECTION METHODS ***/

        /*** VALIDATION METHODS ***/
        this.ModelErrors = ko.validation.group(this);
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {
            return this.IsVMValid();
        }, this);
        /*** VALIDATION METHODS ***/
        sm.portal.vm.custom.callCustomization('OverrideLanguageVMValidation', self);
        
        return self;
    };

    function LanguageDataItem(options) {
        var defaults = {
            LanguageID: 0,
            Proficiency: '',
            IsPrimary: false,
            EducationReceived: '',
            QualificationsObtained: '',
            InEditMode: false,
            ID: -1,
            GID: null,
            Languages: null
        };

        sm.portal.vm.custom.callCustomization('ExtendedPropertiesLanguageDataItem', defaults);
        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        self.LanguageID = ko.validatedObservable(settings.LanguageID);
        self.Language = ko.validatedObservable(settings.Language);
        self.Proficiency = ko.validatedObservable(settings.Proficiency);
        self.IsPrimary = ko.validatedObservable(settings.IsPrimary);
        self.EducationReceived = ko.validatedObservable(settings.EducationReceived);
        self.QualificationsObtained = ko.validatedObservable(settings.QualificationsObtained);
        self.GID = ko.validatedObservable(settings.GID);
        self.ID = ko.validatedObservable(settings.ID);
        self.InEditMode = ko.observable(settings.InEditMode);
        var data = {
            self : self,
            settings : settings
        }
        sm.portal.vm.custom.callCustomization('AddNewPropertiesForLanguageDataItem', data);


        if (settings.Languages == undefined || settings.Languages == null) {
            self.Languages = ko.observableArray();
        } else {
            self.Languages = settings.Languages;
        }

        self.ExtractATO = function () {
            var result = sm.portal.vm.custom.callCustomization('ExtractATOForLanguage', self);
            if (sm.portal.utility.isNullOrEmpty(result)) {
                result = new smapi.community.LanguagesModel({
                            LanguageID: self.LanguageID(),
                            Proficiency: self.Proficiency(),
                            IsPrimary: self.IsPrimary(),
                            EducationReceived: self.EducationReceived(),
                            QualificationsObtained: self.QualificationsObtained,
                            ID: self.ID(),
                            GID: self.GID()
                        });
            }
            return result;
        }

        self.setPrimary = function (primary) {

            self.IsPrimary(primary);
        }

        self.checkReader = ko.computed(function () {

            return self.IsPrimary() ? sm.resources.portalResource.getValue('PrimaryLanguageChecked') : sm.resources.portalResource.getValue('PrimaryLanguageNotChecked');
        })

        self.checkMark = ko.computed(function () {

            return self.IsPrimary() ? 'checked' : '';

        }, this);

        /*** VALIDATION METHODS ***/
        sm.portal.vm.custom.callCustomization('OverrideLanguageValidations', self);

        self.LanguageID.extend({
            min: {
                params: 1,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        self.Proficiency.extend({
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            },
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        self.EducationReceived.extend({
            maxLength: {
                params: 250,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '250')
            }
        });
        self.QualificationsObtained.extend({
            maxLength: {
                params: 250,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '250')
            }
        });


        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid 
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {
            var isCompleted = this.IsVMValid();
            return isCompleted;
        }, this);
        /*** VALIDATION METHODS ***/

        return self;
    };

    jQuery.extend(true, sm.portal.vm, {
        LanguagesViewModel: LanguagesViewModel,
        LanguageDataItem: LanguageDataItem
    });

})(jQuery);